import styles from "./Header.module.css";
import { useDispatch, useSelector } from "react-redux";
import { uiAction } from "../../store/ui-gemini";
import { themeIcon } from "../../asset";
import { useNavigate } from "react-router-dom";
import { chatAction } from "../../store/chat";
import { commonIcon } from "../../asset";
import BranchText from "../Ui/BranchText";
import { IconArrowRight } from "../Ui/Icon";
import { useLocation } from "react-router-dom";

const Header = ({ fullLogo, hideLogin }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isNewChat = useSelector((state) => state.chat.newChat);
  const isUserDetails = useSelector((state) => state.ui.isUserDetailsShow);
  const isLogin = useSelector((state) => state.auth.isLogin);
  const userDetails = useSelector((state) => state.user.user);

  const hiddeUpgrade = () => {
    return location.pathname === "/subs";
  };
  const toggleSideBarHandler = () => {
    dispatch(uiAction.toggleSideBar());
  };

  const toggleAadvanceGeminiHandler = () => {
    dispatch(uiAction.toggleAdvanceShow());
  };

  const icon = themeIcon();

  const newChatHandler = () => {
    dispatch(chatAction.replaceChat({ chats: [] }));
    dispatch(chatAction.newChatHandler());
    dispatch(chatAction.chatHistoryIdHandler({ chatHistoryId: "" }));
    navigate("/home");
  };

  const userDetailsOpen = () => {
    dispatch(uiAction.toggleUserDetailsShow());
  };

  const loginHandler = () => {
    navigate("/login");
    // window.open(continueWithGoogleOauth(), "_self");
  };

  const loginSection = () => {
    if (hideLogin) {
      return <></>;
    }

    if (isLogin) {
      return (
        <>

          <div
            data-tour="profile-icon"
            onClick={userDetailsOpen}
            className={`${styles["user"]} ${
              isUserDetails ? styles["clicked-user"] : ""
            }`}
          >
            {userDetails?.profileImg?.length > 0 ? (
              <img src={userDetails?.profileImg} alt=""></img>
            ) : (
              <img src={commonIcon.defaultAvatar} alt=""></img>
            )}
          </div>
        </>
      );
    }

    return (
      <div className={styles["login"]} onClick={loginHandler}>
        <p>Log in</p>
      </div>
    );
  };
  const publicPath = ['/prayer', '/praise', '/me/submissions']
  let isPublicPage = false

  publicPath.forEach(path => {
    if (location.pathname.includes(path)) {
      isPublicPage = true
    }
  })

  return (
    <div className={styles["header-main"]}>
      <div className={styles["left-section"]}>
        {!fullLogo && isLogin && (
          <div className={styles["menu-icon"]} onClick={toggleSideBarHandler}>
            <img src={commonIcon.menuIcon} alt="menu icon"></img>
          </div>
        )}
        {(fullLogo || isPublicPage) ? (
          <div className={styles["name"]} onClick={() => navigate("/home")}>
            <img
              src={commonIcon.fullLogo2}
              className="!w-40 !h-auto"
              alt="Gospel Truth AI"
              title="Home"
            ></img>
          </div>
        ) : (
          location.pathname.includes("/home/courses") ? 
          <button
            type="button"
            onClick={() => navigate(location.pathname.includes("player") ? '/home/courses' : '/home')}
            className="inline-flex items-center gap-2 px-3 py-2 rounded-lg border hover:bg-gray-50 text-sm"
            aria-label="Back to Home"
            title="Back to Home"
          >
            <span className="-ml-0.5">←</span>
            <span> {location.pathname.includes("player") ? "Back to Courses" : "Back to Home"}</span>
          </button>
          : (
          <div
            className="inline-flex gap-2 items-center cursor-pointer"
            onClick={toggleAadvanceGeminiHandler}
          >
            <BranchText hasChatType={true} />
            <img
              className="!size-3"
              src={icon.dropIconSmall}
              alt="drop down button"
            ></img>
          </div>
          )
        )}
      </div>
      <div className={styles["right-section"]}>
        {isNewChat && isLogin ? (
          <div
            onClick={newChatHandler}
            className={`${styles["plus-icon"]} ${styles["new-plus-icon"]}`}
          >
            <img
              src={icon.plusIcon}
              alt="plus icon"
              title="Click Here for New Chat"
            ></img>
          </div>
        ) : null}
        
        {!hiddeUpgrade() && (
            <button
              data-tour="upgrade-button"
              onClick={() => isLogin ? navigate("/subs") : navigate("/signup")}
              className="hidden md:inline-flex justify-center items-center gap-1 text-white bg-[#0173B8] border border-gray-300 focus:outline-none hover:bg-gray-100 hover:text-black focus:ring-4 focus:ring-gray-100 font-medium rounded-lg text-sm md:px-5 md:py-2.5 p-1 me-2"
            >
              Upgrade to $19.95
              <IconArrowRight size="4" />
            </button>
          )}
           {!hiddeUpgrade() && (
          <>
            {/* Desktop button */}
            <button
              onClick={() => dispatch(uiAction.toggleSlide())}
              className="hidden md:inline-flex justify-center items-center gap-1 text-[#0173B8] bg-white border border-gray-300 hover:bg-gray-100 focus:outline-none focus:ring-4 focus:ring-gray-100 font-medium rounded-lg text-sm md:px-5 md:py-2.5 p-1 me-2"
              aria-label="Open Music Study Serve"
              title="Music Study Serve"
            >
              The Gaither Music, Study, Serve
            </button>

            {/* Mobile vertical button */}
            <button
              onClick={() => dispatch(uiAction.toggleSlide())}
              className={`md:hidden fixed right-0 top-1/4 transform -translate-y-1/4 z-[5] bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-l-full px-1 py-6 transition-all duration-200 hover:scale-105 ${styles["gentle-attraction"]}`}
              aria-label="Open Music Study Serve"
              title="Music Study Serve"
            >
              <div className="flex flex-col items-center gap-2">
                <div className={`${styles["vertical-text"]} text-sm whitespace-nowrap`}>
                Gaither Music
                </div>
                <div className="w-4 h-4 bg-white rounded-full flex items-center justify-center animate-bounce">
                  <span className="text-blue-600 text-xs">→</span>
                </div>
              </div>
            </button>
          </>
        )}
        {loginSection()}
      </div>
    </div>
  );
};

export default Header;
